import React, { useState, useEffect } from 'react';
import { Link, Button } from '@heroui/react';
import { XMarkIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

const FirstVisitBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has dismissed the banner before
    const hasSeenBanner = localStorage.getItem('clipkite-legal-banner-dismissed');
    if (!hasSeenBanner) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('clipkite-legal-banner-dismissed', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-primary-50 dark:bg-primary-950/30 border-t border-primary-200 dark:border-primary-800 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1">
            <InformationCircleIcon className="w-5 h-5 text-primary-600 dark:text-primary-400 flex-shrink-0" />
            <p className="text-sm text-foreground/80">
              By using ClipKite, you agree to our{' '}
              <Link
                href="/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-primary font-medium"
                size="sm"
              >
                Terms of Service
              </Link>
              {' '}and{' '}
              <Link
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-primary font-medium"
                size="sm"
              >
                Privacy Policy
              </Link>
              .
            </p>
          </div>
          <Button
            isIconOnly
            variant="light"
            size="sm"
            onPress={handleDismiss}
            className="flex-shrink-0"
            aria-label="Dismiss banner"
          >
            <XMarkIcon className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FirstVisitBanner;
